export class DefaultService { }